<template>
    <b-card no-body class="shadow rounded">
        <b-card-title class="m-3">Bekijk de wensen van anderen in de groep</b-card-title>
        <b-list-group v-if="hasUsers" class="list-group-flush">
            <b-list-group-item v-for="(user, index) in users" :key="index" class="flex-column align-items-start px-0 ">
                <h5 class="d-flex w-100 justify-content-between align-items-center pointer px-4 pb-1" v-on:click="getWishlist(user.id)" :id="'wishlist-' + user.id" v-bind:class="{'text-danger': isActive(user.id)}" v-scroll-to="{ el: '#wishlist-' + user.id, offset: -100}">
                    <div>
                        <font-awesome-icon v-if="!isActive(user.id)" icon="angle-double-right" />
                        <font-awesome-icon v-else icon="angle-double-down" />
                        <span class="ml-2">{{ user.name }}</span>
                    </div>
                    <small><font-awesome-icon icon="gift" /></small> 
                </h5>
                <b-card-body v-if="wishlist && wishlist.participant == user.id" class="p-0">
                    <span v-if="!hasItems" class="ml-4">🤔<i class="ml-2">heeft nog niets ingevuld...</i></span>
                    <b-list-group v-if="hasItems" class="list-group-flush">
                        <b-list-group-item v-for="(item, index) in wishlist.items" :key="index" class="d-flex w-100 justify-content-start align-items-start shadow pt-3">
                            <b-button variant="outline-danger" :class="{'btn-danger': item.completed, 'btn-toggle': true}" v-if="participant.id" :disabled="item.completed && item.completed != participant.id" v-on:click="toggleItem(item, participant.id)"></b-button>
                            <vue-markdown class="w-100 px-3" v-if="participant.id" :anchorAttributes="{ target: '_blank' }" :class="{'completed': !!item.completed}" :source="item.description"></vue-markdown>

                            <font-awesome-icon icon="gift" v-if="!participant.id" />
                            <vue-markdown class="w-100 px-3" v-if="!participant.id" :anchorAttributes="{ target: '_blank' }" :source="item.description"></vue-markdown>
                        </b-list-group-item>
                    </b-list-group>
                </b-card-body>
            </b-list-group-item>
        </b-list-group>
        <b-card-body v-else>
            <b-alert variant="warning">geen gebruikers</b-alert>
        </b-card-body>
    </b-card>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { apiUrl } from '@/config'

export default {
  computed: mapState({
    participant: state => state.participants.participant,
    users: state => state.events.event.users.filter(u => u.id != state.participants.participant.id),
    wishlist: state => state.wishlists.wishlist,
    hasUsers: state => state.events.event.users.length > 0,
    hasItems: state => state.wishlists.wishlist.items.length > 0,
  }),
  methods: {
    getWishlist(user) {
      this.$store.dispatch('wishlists/getWishlist', user);
    },
    isActive(userId) {
      if (this.wishlist) { return this.wishlist.participant == userId; }
      return false;
    },
    toggleItem(item, id) {
        if (!item.completed || item.completed == id) {
            if (!item.completed) {
                item = { ...item, completed: id };
            } else if (item.completed == id) {
                item = { ...item, completed: null };
            }
            return axios.put(`${apiUrl}/api/wishlist/item/${item.id}`, item)
                .then(response => { this.getWishlist(this.wishlist.participant); })
                .catch(e => { console.log(e) });
        }
    }
  },
}
</script>

<style lang="scss" scoped>
.pointer {
    cursor: pointer;
}

.completed {
    text-decoration: line-through;
}

.btn-toggle {
    height: 1.6rem;
}
</style>
